import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withTranslation, WithTranslation } from 'react-i18next';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import Cookies from 'js-cookie';
// Components
import ErrorMessage from '../../components/error-message';
import MainLoading from '../../components/main-loading';
// Modules
import { actions as loginActions } from '../../redux/reducers/login';
import { selectors as errorSelectors, ErrorPayload } from '../../redux/reducers/errors';
// Ressources
import packageJson from '../../../package.json';
import styles from './login-style';

interface LoginIDProps extends WithTranslation, WithStyles {
    loginError: ErrorPayload;
    loginID: (token: string, error: Function) => any;
    redirectToID: () => any;
}

const LoginIDPage = (props: LoginIDProps): JSX.Element => {
    const { t, classes, loginError, loginID, redirectToID } = props;

    const [token] = React.useState<string>(Cookies.get('token'));
    const [message, setMessage] = React.useState<string>(t('loginID.cookies'));

    const loginIdAcceptedTimer: React.MutableRefObject<NodeJS.Timeout> = React.useRef(null);
    const loginIdRedirectTimer: React.MutableRefObject<NodeJS.Timeout> = React.useRef(null);
    const loginIdAcceptedRedirectTimer: React.MutableRefObject<NodeJS.Timeout> = React.useRef(null);
    const loginIdFailedTimer: React.MutableRefObject<NodeJS.Timeout> = React.useRef(null);
    const loginIdFailedRedirectTimer: React.MutableRefObject<NodeJS.Timeout> = React.useRef(null);

    useEffect(() => {
        // console.log(token);
        if (token) {
            loginIdAcceptedTimer.current = setTimeout(() => setMessage(t('loginID.accepted')), 1000);
            loginIdRedirectTimer.current = setTimeout(
                () =>
                    loginID(token, (msg) => {
                        // Error cases
                        setMessage(t(msg));
                        loginIdAcceptedRedirectTimer.current = setTimeout(() => redirectToID(), 4000);
                    }),
                2000,
            );
        } else {
            loginIdFailedTimer.current = setTimeout(() => setMessage(t('loginID.redirect')), 1000);
            loginIdFailedRedirectTimer.current = setTimeout(() => redirectToID(), 2000);
        }
        return () => {
            clearTimeout(loginIdAcceptedTimer.current);
            clearTimeout(loginIdRedirectTimer.current);
            clearTimeout(loginIdAcceptedRedirectTimer.current);
            clearTimeout(loginIdFailedTimer.current);
            clearTimeout(loginIdFailedRedirectTimer.current);
        };
    }, [token, t, redirectToID, loginID]);

    return (
        <div className={classes.root}>
            {/* Top Bar view */}
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <Typography variant="h6" noWrap>
                        {t('menu:app_name')}
                        {` v${packageJson.version}`}
                    </Typography>
                </Toolbar>
            </AppBar>
            {/* Content */}
            <div className={classes.content}>
                <div className={classes.toolbar} />
                <div className={classes.message}>
                    <ErrorMessage payload={loginError} />
                    <MainLoading center />
                    {message}
                </div>
            </div>
        </div>
    );
};

const ComponentWithStyle = withStyles(styles)(LoginIDPage);
const ComponentWithTranslationAndStyle = withTranslation(['login', 'menu', 'common'])(ComponentWithStyle);

const mapStateToProps = (state) => ({
    loginError: errorSelectors.loginIDError(state),
});

const mapDispatchToProps = {
    loginID: loginActions.loginID,
    redirectToID: loginActions.redirectToID,
};

export default connect(mapStateToProps, mapDispatchToProps)(ComponentWithTranslationAndStyle);
